// Components==============
import Avatar from 'components/UI/Avatar/Avatar';
import Checkbox from 'components/UI/Checkbox/Checkbox';
import { useTranslate } from 'hooks/useTranslate';
import React, { useContext } from 'react';
import { DeleteModalContext, SelectedUserType } from '../../DeleteModal';
import '../../DeleteModal.module.scss';
// =========================

export const User = ({
  user,
  name,
}: {
  user: SelectedUserType;
  name: string;
}) => {
  const {
    selectedUsers,
    setSelectedUsers,
    themeIsChecked,
    processIsChecked,
    transferUser,
  } = useContext(DeleteModalContext);

  const isChecked = selectedUsers
    .map((u) => u.memberId)
    .includes(user.memberId);

  return (
    <Checkbox
      isChecked={isChecked}
      onClick={
        themeIsChecked || processIsChecked || transferUser
          ? undefined
          : () =>
              setSelectedUsers((prev) =>
                isChecked
                  ? prev.filter((s) => s.memberId !== user.memberId)
                  : [...prev, user]
              )
      }
    >
      <div styleName="user">
        <Avatar user={user.user} />
        <p>{name}</p>
      </div>
    </Checkbox>
  );
};

export default function Users() {
  const translate = useTranslate();

  const { allUsers, canDelete } = useContext(DeleteModalContext);

  return (
    <div styleName="leave-groups">
      <div>
        {!!canDelete && (
          <h3>
            {translate(
              `project.leave-project.title.${
                allUsers.length > 1 ? 'multiple' : 'single'
              }`
            )}
          </h3>
        )}
        <p>
          {translate(
            `project.leave-project.description.${
              allUsers.length > 1 ? 'multiple' : 'single'
            }`
          )}
        </p>
      </div>
      <div styleName="body">
        {allUsers.map(
          (s) =>
            s.user && (
              <User
                key={s.user.id}
                name={s.name}
                user={{ user: s.user, memberId: s.memberId }}
              />
            )
        )}
      </div>
    </div>
  );
}
